import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const GridFilter = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  grid-column-start: 1;
  grid-column-end: span 12;

  ${breakpoints.md} {
    flex-direction: row;
  }
`;

export const FilterSelectGroup = styled.div`
  margin: 32px 0;

  ${breakpoints.md} {
    margin: 0;
    display: flex;
    flex-direction: row;

    &:first-child {
      margin-right: 32px;
    }
  }
`;
